/**
 * alert.ts · BunchAlert wire type (Phase 4)
 * Mirrors backend/app/schemas/alerts.py — the Phase 4 contract that comes
 * in-band on the /ws/vehicles envelope AND on GET /api/alerts. UI helpers
 * (headline, display-state fold-through) live on `BunchAlertUi` so the
 * wire shape stays pristine for round-trip.
 */
/**
 * Adapter — wire alert → dashboard alert. Idempotent, pure. The rail
 * uses this to fold the wire shape into the render shape without
 * mutating the underlying frame.
 */
export function toBunchAlertUi(a) {
    const [leader, follower] = a.vehicles;
    const lead = a.forecast_lead_s >= 60
        ? `${Math.round(a.forecast_lead_s / 60)}m ${Math.round(a.forecast_lead_s % 60)}s`
        : `${Math.round(a.forecast_lead_s)}s`;
    return {
        ...a,
        displayState: a.state,
        headline: `Route ${a.route_id} · ${leader} → ${follower} · pair in ${lead}`,
    };
}
